<template>
    <div class="container">
        <div class="pageLogoContainer">
            <img src="../assets/basis/PageLogo.png" class="pageLogo" alt="">
        </div>
    </div>
</template>

<script>
export default {
  name: 'home',
  props: ['footlogo'],
  mounted: function () {
    // 倒數 5秒 切換到第一頁
    $('.pageLogoContainer').addClass('active')
    var thisData = this
    var thisRouter = this.$router
    setTimeout(function () {
      thisData.$emit('update:footlogo', true)
      thisRouter.push('/step0')
    }, 2000)
  }
}
</script>

<style scoped>
    .pageLogoContainer {transition:.5s;opacity:0;}
    .pageLogoContainer.active {opacity:1;}
</style>



// WEBPACK FOOTER //
// src/components/home.vue